import { Marker, GoogleMap as Map } from '@react-google-maps/api';
import React from 'react';

export default function GoogleMap({ location, width = '100%', height = '100%' }) {
  const containerStyle = {
    width,
    height,
  };

  const mapOptions = {
    disableDefaultUI: true,
    draggable: false,
    zoomControl: false,
    scrollwheel: false,
    gestureHandling: 'none',
  };

  return (
    <div>
      <Map mapContainerStyle={containerStyle} center={location} zoom={15} options={mapOptions}>
        <Marker position={location} />
      </Map>
    </div>
  );
}
